import React from 'react';
import { Content } from '~/layouts/Dash/components';


const BasicContent = ({breadcrumb, children}) => {

  const breadcrumbs = [
    {
      label: 'Estado',
      to: '/estado',
      active: false,
    },
    breadcrumb,
  ];
  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Estados"
    >
      {children}
    </Content>
  );
}

export default BasicContent;
